// Vue section
import Vue from 'vue/dist/vue.esm';
import VueResource from 'vue-resource'
import Vue2Filters from 'vue2-filters'
import ImageUploader from 'vue-image-upload-resize'

// Custom components
import byCard from 'components/checkout_sessions/by_card'
import byCheck from 'components/checkout_sessions/by_check'

// 3d party components
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEnvelope, faPhone, faUser, faHandHoldingUsd, faSpinner, faCreditCard, faFileInvoice, faStickyNote, faCheck } from '@fortawesome/free-solid-svg-icons'
import { faCcVisa } from '@fortawesome/free-brands-svg-icons'
import VeeValidate from 'vee-validate'
import M from '../stylesheets/materialize-src/js/bin/materialize'
import VueMask from 'v-mask'

import '../stylesheets/checkout_session.scss'

library.add(faEnvelope, faPhone, faUser, faSpinner, faCreditCard, faHandHoldingUsd, faFileInvoice, faStickyNote, faCcVisa, faCheck)

Vue.use(Vue2Filters)
Vue.use(VueResource)
Vue.use(ImageUploader)
Vue.use(VeeValidate,
  {
    classes: true,
    classNames: {
      valid: 'valid',
      invalid: 'invalid'
    }
  });
Vue.use(VueMask);

Vue.http.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

Vue.component('by-card', byCard)
Vue.component('by-check', byCheck)
Vue.component('font-awesome-icon', FontAwesomeIcon)

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '[data-behavior="vue"]'
  })
})

// Configure Events bus
const bus = new Vue()
Vue.prototype.$bus = bus
Vue.prototype.$dom = dom

Vue.prototype.$webkit = window.webkit;
Vue.prototype.$android = window.Android;
Vue.mixin({
  data: function () {
    return {
    }
  },
  methods: {
    notifyError(message) {
      M.toast({html: message, classes: 'red darken-1'})
    },
    notifySuccess(message) {
      M.toast({html: message, classes: 'emerald-back'})
    },
    errorHandler(error) {
      if(error.status == 422) {
        this.notifyError(error.body.error_messages[0])
      } else if(error.status == 429) {
        this.notifyError('Too many requests. Please try again later')
      }
      else {
        this.notifyError('Something went wrong')
      }
    }
  }
})
